// src/services/settings.js
import api from './api';

export const getSettings = async () => {
  const response = await api.get('/settings');
  return response.data;
};

export const updateSetting = async (key, value) => {
  const response = await api.put(`/settings/${key}`, { value });
  return response.data;
};

export const bulkUpdateSettings = async (settings) => {
  const response = await api.put('/settings', { settings });
  return response.data;
};

// New function: create a new setting (super admin only)
export const createSetting = async (data) => {
  const response = await api.post('/settings', data);
  return response.data;
};
export const getContributionAmount = async () => {
  const response = await api.get('/settings/contribution-amount');
  return response.data.amount;
};
export const getCaseTypes = async () => {
  const response = await api.get('/settings/case-types');
  return response.data;
};

export const getCaseAmount = async (type) => {
  const response = await api.get(`/settings/case-type-amount/${type}`);
  return response.data.amount;
};